export default __webpack_public_path__ + "static/media/dont.5d33cb9b.png";